





export const fetchSousCategories = async (setDicoCategories, setSousCategories) => {
    try {
        const response = await fetch("https://carto.api.toobib.org/api/get_categories");

        if (!response.ok) {
            throw new Error("Error fetching sous categories");
        }

        const data = await response.json();

        if (!data || data.length === 0) {
            console.warn("No data found in the table!");
            return;
        }

        const dicoCategoriesMap = {};
        data.forEach(item => {
            const sousCategorie = item.sous_categorie || "Unspecified";
            if (item.categories && Array.isArray(item.categories)) {
                item.categories.forEach(categorie => {
                    if (!dicoCategoriesMap[categorie]) {
                        dicoCategoriesMap[categorie] = new Set();
                    }
                    dicoCategoriesMap[categorie].add(sousCategorie);
                });
            }
        });

        const dicoCategories = Object.fromEntries(
            Object.entries(dicoCategoriesMap)
                .sort(([keyA], [keyB]) => keyA.localeCompare(keyB)) 
                .map(([key, value]) => [key, Array.from(value).sort()])
        );

        setDicoCategories(dicoCategories);

        const uniqueSousCategories = [
            ...new Set(data.map(item => item.sous_categorie))
        ].sort();

        setSousCategories(uniqueSousCategories);
    } catch (error) {
        console.error("Error fetching sous categories and dico from the server:", error);
    }
};






export const fetchData = async (coordinates, radius, selectedSousCategories, selectedCategories, setFilteredData, selectedProfessions, setPraticiensData) => {
   
    
    
    if (selectedProfessions.length === 0) {
        setPraticiensData([])

        try {
            
            const params = new URLSearchParams();
            params.append('user_lat', coordinates.lat);
            params.append('user_lng', coordinates.lng);
            params.append('search_radius', radius);
            params.append('selected_sous_categories', selectedSousCategories.length > 0 ? selectedSousCategories.join(',') : '');

            const response = await fetch(`https://carto.api.toobib.org/api/get_filtered_data?${params.toString()}`);

            if (!response.ok) {
                throw new Error('Error fetching filtered data');
            }

            const data = await response.json();

            setFilteredData(data);
            
        } catch (err) {
            console.error('Error fetching filtered data:', err);
        }
    } else {

        setFilteredData([]);  
        
    }
};






export const fetchPSdansEtablissement = async (finess_et, setPersonnesTravaillantDansEtablissement) => {
    try {
        const params = new URLSearchParams();
        params.append('num_finess', finess_et);

        const response = await fetch(`https://carto.api.toobib.org/api/finess_praticiens?${params.toString()}`);

        if (!response.ok) {
            throw new Error('Error fetching practitioners data');
        }

        const data = await response.json();

        setPersonnesTravaillantDansEtablissement(data);
    } catch (err) {
        console.log(err);
    }
};






export async function migrerPraticien(ancienNumFiness, rppsId, nouveauNumFiness) {
    // Vérification de la présence des paramètres
    if (!ancienNumFiness || !rppsId) {
      throw new Error("Missing required parameters: ancienNumFiness, rppsId.");
    }

  
  
    const url = 'https://carto.api.toobib.org/api/migrer_praticiens'; 

    const requestBody = {
      ancien_numero_finess: ancienNumFiness,
      rpps_id: rppsId,
      nouveau_numero_finess: nouveauNumFiness
    };
  
    try {
      
      const response = await fetch(url, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json', 
        },
        body: JSON.stringify(requestBody), 
      });
      if (response.ok) {
        console.log('Praticien migré avec succès !');
      } else {
        const errorData = await response.json(); 
        throw new Error(`Erreur: ${errorData.error}`);
      }
    } catch (error) {
      console.error('Erreur lors de la migration du praticien:', error);
    }
}
  



export async function ajouterPraticien(numeroFiness, rppsId) {
  
  if (!numeroFiness || !rppsId) {
      throw new Error("Les paramètres 'numeroFiness' et 'rppsId' sont obligatoires");
  }

  const url = 'https://carto.api.toobib.org/api/ajouter_praticien';
  const requestBody = {
      numero_finess: numeroFiness,
      rpps_id: rppsId
  };

  try {
      const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
          
      });

      const responseData = await response.json();
      
      console.log(`Praticien ${rppsId} ajouté avec succès à l'établissement ${numeroFiness}`);
      return responseData; 

  } catch (error) {
      console.error('Erreur lors de l\'ajout du praticien:', {
          error: error.message,
          numeroFiness,
          rppsId
      });
      throw error; 
  }
}














export const fetchHorairesForAll = async (praticiens, setHorairesData) => {
    try {
        const rppsIds = praticiens.map(p => p.rpps_id);

        const params = new URLSearchParams();
        params.append('rpps_ids', rppsIds.join(',')); 

        const response = await fetch(`https://carto.api.toobib.org/api/horaires_praticiens?${params.toString()}`);

        if (!response.ok) {
            throw new Error('Error fetching horaires data');
        }

        const data = await response.json();
        

        const horairesMap = {};
        data.forEach(({ rpps_id, horaires }) => {
            horairesMap[rpps_id] = horaires || []; 
        });

        setHorairesData(horairesMap);
    } catch (err) {
        console.log("Error fetching horaires:", err);
    }
};



export const fetchPraticiens = async (coordinates, radius, selectedProfessions, setPraticiensData) => {
    if (selectedProfessions.length>0){
        
        try {
            const params = new URLSearchParams();
            console.time("Temps d'execution de la requête des praticiens")
            params.append('user_lat', coordinates.lat);
            params.append('user_lng', coordinates.lng);
            params.append('search_radius', radius);
            if (selectedProfessions.length > 0) {
                params.append('selected_professions', selectedProfessions.join(','));
            }
            //console.log(`https://carto.api.dev.toobib.org/api/get_praticiens_data?${params.toString()}`)
            const response = await fetch(`https://carto.api.toobib.org/api/get_praticiens_data?${params.toString()}`);

            if (!response.ok) {
                throw new Error('Error fetching praticiens data');
            }

            const data = await response.json();
            setPraticiensData(data);
            console.timeEnd("Temps d'execution de la requête des praticiens")
        } catch (err) {
            console.error('Error fetching praticiens data:', err);
        } 
}
};


export const fetchModifications=async(setModificationsHistoriques)=>{
    try {
        const response=await fetch("https://carto.api.toobib.org/api/finess_modifications")
        const data=await response.json()
        setModificationsHistoriques(data)
    }
    catch(err){
        console.error("On a pas réussi à charger les modifications")
    }
}

export const fetchMigrations=async(setMigrationsPraticiens)=>{
  try {
      const response=await fetch("https://carto.api.toobib.org/api/praticiens_migrations")
      const data=await response.json()
      setMigrationsPraticiens(data)
  }
  catch(err){
      console.error("On a pas réussi à charger les migrations")
  }
}


export const fetchReferentiels=async(setReferentiels)=>{
    try {
        const response=await fetch("https://carto.api.toobib.org/api/get_referentiels")
        const data=await response.json()
        setReferentiels(data)
    }
    catch(err){
        console.error("On a pas réussi à charger les referentiels")
    }
}






export const getFinessInformation = async (numeroDeFiness, setData) => {
    if (!numeroDeFiness) {
      return;
    }

    const url = `https://carto.api.toobib.org/api/get_informations_finess_precis?numero_de_finess=${numeroDeFiness}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        setData(null);  
        return;
      }

      const resultData = await response.json(); 
      console.log("resultat api", resultData)
      setData(resultData);  
    } catch (error) {
      console.error("Erreur lors de l'appel API:", error);
      setData(null);  
}
};


export const validerModification= async (numeroFiness, isAdmin, besoinRefresh, setBesoinRefresh, setEtablissementChoisi)=> {
    if (!isAdmin) {
      return;  
    }
    const url = 'https://carto.api.toobib.org/api/valider_une_modification';  
    const data = { numero_finess: numeroFiness };
  
    try {
      const response = await fetch(url, {
        method: 'POST',  
        headers: {
          'Content-Type': 'application/json'  
        },
        body: JSON.stringify(data)  
      });
  
      if (response.ok) {
        setBesoinRefresh(!besoinRefresh)
        setEtablissementChoisi(null)
        
      } else {
        console.error('Erreur')
      }
    } catch (error) {
      console.error('Erreur de réseau:', error);
    }
  }

  

  export const rejeterModification= async (numeroFiness, isAdmin, besoinRefresh, setBesoinRefresh, setEtablissementChoisi)=> {
    if (!isAdmin) {
      return;  
    }
    const url = 'https://carto.api.toobib.org/api/rejeter_une_modification';  
    const data = { numero_finess: numeroFiness };
  
    try {
      const response = await fetch(url, {
        method: 'POST',  
        headers: {
          'Content-Type': 'application/json'  
        },
        body: JSON.stringify(data)  
      });
  
      if (response.ok) {
        setBesoinRefresh(!besoinRefresh)
        setEtablissementChoisi(null)
        
      } else {
        console.error('Erreur')
      }
    } catch (error) {
      console.error('Erreur de réseau:', error);
    }
  }
  




export const upload_siteweb=async (establishment, newSiteWeb, setNewSiteWeb) =>{
    if (!establishment?.finess_et || !newSiteWeb) {
      console.error("Erreur : FINESS ou site web manquant.");
      return { success: false, message: "Données manquantes." };
    }
    console.log(establishment.finess_et)
    console.log(newSiteWeb)
    try {
      const response = await fetch("https://carto.api.toobib.org/api/ajout_site_web", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          finess_et: establishment.finess_et,
          site_web: newSiteWeb,
        }),
      });
  
      const data = await response.json();
      
      if (!response.ok) {
        console.error("Erreur API :", data.message);
        return { success: false, message: data.message };
      }
      setNewSiteWeb("")
      return { success: true, message: data.message };
    } catch (error) {
      return { success: false, message: "Erreur réseau." };
    }
  }
  




export const getRPPSInformation = async (rppsId, setData) => {
    if (!rppsId) {
        return;
    }

    const url = `https://carto.api.toobib.org/api/get_rpps_information?rpps_id=${rppsId}`;

    try {
        
        const response = await fetch(url);
        
        if (!response.ok) {
            setData(null);  
            return;
        }

        const resultData = await response.json(); 
        setData(resultData);  
    } catch (error) {
        console.error("Erreur lors de l'appel API:", error);
        setData(null);  
    }
}